import TagManager from '../../../classes/TagManager';
import ProductListSlider from '../../organisms/productListSlider/ProductListSlider';
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { optionsRelated, titleOptions } from './utils/options';
import { isEmptyObject, isPlainObject } from '../../../utils/assertions';
import { useNostoContext } from '../../../provider/nosto/NostoContext';
import { parseProducts } from '../../../provider/nosto/utils';

const RelatedProducts = ({
  relatedTitle,
  relatedPlacement,
  nostoProductClick,
}) => {
  const { wishlist } = useSelector((state) => state.wishlist);
  const { placementData } = useNostoContext();
  const blockRef = useRef(null);

  const nostoTitle = placementData[relatedPlacement]?.title;
  const title = nostoTitle ?? (relatedTitle || titleOptions['related'].title);

  const { xlSlidesPerView, mdSlidesPerView, lgSlidesPerView } = optionsRelated;

  useEffect(() => {
    if (
      isPlainObject(placementData) &&
      isPlainObject(placementData[relatedPlacement]) &&
      !isEmptyObject(placementData[relatedPlacement]?.products)
    ) {
      TagManager.productImpressionsDynamic(
        placementData[relatedPlacement]?.products,
        title,
      );
    }
  }, [placementData]);

  return isPlainObject(placementData) &&
    isPlainObject(placementData[relatedPlacement]) &&
    placementData[relatedPlacement]?.products?.length > 2 ? (
    <>
      <span ref={blockRef} />
      <ProductListSlider
        placement="product"
        titleAlign="center"
        smSlidesPerView="auto"
        mdSlidesPerView={mdSlidesPerView} // fractions set to compensate swiper.js weird behavior if slides offsets set
        lgSlidesPerView={lgSlidesPerView}
        xlSlidesPerView={xlSlidesPerView}
        smOffsets={20}
        mdOffsets={20}
        lgOffsets={40}
        xlOffsets={143}
        products={parseProducts(placementData[relatedPlacement]?.products)}
        listName={title}
        wishlist={wishlist}
        title={title}
        type="related-products"
        scrollBarVisibility="mobile"
        centerInsufficientSlides
        autoplay
        nostoPlacement={relatedPlacement}
        nostoCallback={nostoProductClick}
      />
    </>
  ) : null;
};

export default RelatedProducts;
